import $ from 'jquery'

class Scroller {

	static _scroll(to, duration) {
		$("html,body").animate({ scrollTop: to }, duration, "swing")
	}

	static scrollToPosition(px) {
		const diff = Math.abs($(window).scrollTop() - px)
		let duration = diff / 10.0
		duration = (duration < 100) ? 100 : duration
		duration = (duration > 500) ? 500 : duration
		this._scroll(px, duration)
	}

	static scrollToElement(el) {
		const target = $(el)
		let destination = 0
		if(!target || !target.offset()) return
		destination = target.offset().top - 1
		const marginTop = target.css("margin-top")
		destination -= parseFloat(marginTop)
		this.scrollToPosition(destination)
	}

}

export default Scroller



// WEBPACK FOOTER //
// ./src/components/AnchorNav/Scroller.js